import { Box, IconButton, useTheme, Portal, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";
import HistoryTable from "./HistoryTable";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import { useSoundStore } from "../../stores/soundStore/useSoundStore";
import { setIsMuted } from "../../stores/soundStore/soundStore";
import { useTranslate } from "../../hooks/useTranslate";

function HistoryBtn() {
  const [showModal, setShowModal] = useState(false);
  const { isMuted } = useSoundStore();
  const theme = useTheme();
  const toggleMuted = () => {
    setIsMuted(!isMuted);
  };
  const { t } = useTranslate();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: 0.375,
          cursor: "pointer",
        }}
      >
        <Tooltip title={isMuted ? t("historyTable.unmute") : t("historyTable.mute")}>
          <IconButton
            onClick={toggleMuted}
            aria-label={isMuted ? t("historyTable.unmute") : t("historyTable.mute")}
            color="inherit"
            sx={{
              p: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isMuted ? (
              <VolumeOffIcon
                sx={{
                  color: "#FFFFFF",
                  fontSize: theme.breakpoints.down("sm") ? theme.typography.pxToRem(20) : theme.typography.pxToRem(50),
                }}
              />
            ) : (
              <VolumeUpIcon
                sx={{
                  color: "#FFFFFF",
                  fontSize: theme.typography.pxToRem(20),
                }}
              />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title={t("historyTable.showHistory")}>
          <IconButton
            aria-label={t("historyTable.showHistory")}
            onClick={() => {
              setShowModal(true);
            }}
            sx={{
              p: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <InfoOutlinedIcon
              sx={{
                color: "#FFFFFF",
                fontSize: theme.typography.pxToRem(20),
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
      {showModal && (
        <Portal>
          <HistoryTable onClose={() => setShowModal(false)} />
        </Portal>
      )}
    </>
  );
}

export default HistoryBtn;
